module.exports = __webpack_public_path__ + "img/best-value.bcf03c0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/best-value.png
// module id = ./assets/img/best-value.png
// module chunks = 11